import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RecentActivityFeed = ({ activities }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'text-green-600 bg-green-50';
      case 'pending':
        return 'text-orange-600 bg-orange-50';
      case 'processing':
        return 'text-blue-600 bg-blue-50';
      case 'draft':
        return 'text-purple-600 bg-purple-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed':
        return 'تکمیل شده';
      case 'pending':
        return 'در انتظار بررسی';
      case 'processing':
        return 'در حال پردازش';
      case 'draft':
        return 'پیش‌نویس آماده';
      default:
        return 'نامشخص';
    }
  };

  const getCaseTypeIcon = (caseType) => {
    switch (caseType) {
      case 'اظهارنامه قضایی':
        return 'FileText';
      case 'شکایت':
        return 'AlertTriangle';
      case 'لایحه':
        return 'ScrollText';
      default:
        return 'File';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fa-IR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })?.format(date);
  };

  if (!activities || activities?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-xl p-8 text-center">
        <Icon
          name="FileText"
          size={48}
          className="text-muted-foreground mx-auto mb-4"
        />
        <h3 className="text-lg font-medium text-foreground mb-2">
          هنوز درخواستی ندارید
        </h3>
        <p className="text-muted-foreground mb-4">
          اولین درخواست خود را برای تهیه سند حقوقی ایجاد کنید
        </p>
        <Button
          variant="default"
          onClick={() => navigate('/new-request-form')}
          iconName="Plus"
          iconPosition="right">
          درخواست جدید
        </Button>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">
          فعالیت‌های اخیر
        </h2>
        <Button
          variant="ghost"
          onClick={() => navigate('/requests-management')}
          iconName="ArrowLeft"
          iconPosition="left">
          مشاهده همه
        </Button>
      </div>
      <div className="space-y-4">
        {activities?.map((activity) => (
          <div
            key={activity?.id}
            className="flex items-center space-x-4 space-x-reverse p-4 bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors duration-150">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon
                  name={getCaseTypeIcon(activity?.caseType)}
                  size={20}
                  className="text-primary"
                />
              </div>
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 space-x-reverse mb-1">
                <h4 className="text-sm font-medium text-foreground truncate">
                  {activity?.caseType}
                </h4>
                <span
                  className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                    activity?.status
                  )}`}>
                  {getStatusText(activity?.status)}
                </span>
              </div>
              <p className="text-sm text-muted-foreground truncate">
                {activity?.subject}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {formatDate(activity?.createdAt)}
              </p>
            </div>

            <div className="flex-shrink-0">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate(`/requests-management`)}
                iconName="Eye"
                iconPosition="right">
                مشاهده
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivityFeed;
